import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<span class=\"loader\"></span>",{ moduleName: "frontend/components/inputs/select-search/loading/template.hbs" })